import * as React from "react";
import {
  IXGUIFieldBase,
  TOnChange,
} from "../../../utils/interfaces/gui/fields.interfaces";

import { Divider, Stack, TextField, Typography } from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const compareProps = (prevProps: any, nextProps: any) => {
  // return isEqual(prevProps, nextProps);
  return prevProps.currentValue === nextProps.currentValue;
};

interface XGUITextFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
  type: "number" | "text";
}

const XGUITextField: React.FC<XGUITextFieldProps> = React.memo(
  ({ field, currentValue, onChange, type = "text" }) => {
    const id = `XGUI-FIELD-${field.name}`;
    const bp = useBreakpoint();

    return (
      <React.Fragment>
        <Stack
          className="XGUIField"
          direction="row"
          justifyContent="space-between"
          alignItems={type === "number" ? "center" : "flex-start"}
          mb={1}
        >
          {/* <AntSwitch
            size="small"
            sx={{ mr: 1 }}
            checked={!disabled}
            onChange={(e) => {
              setDisabled(!e.target.checked);
              debounced(value);
            }}
          /> */}
          <Typography component="label" htmlFor={id} width="40%">
            {field.label}
          </Typography>
          <TextField
            id={id}
            sx={{ ml: 1 }}
            fullWidth
            hiddenLabel
            size="small"
            type={type}
            multiline={type !== "number"}
            maxRows={3}
            placeholder={field.placeholder ?? field.label}
            value={currentValue ?? field.defaultValue}
            onChange={(e) => {
              let value: any = e.target.value;

              if (type === "number") {
                value = parseInt(value) as any;

                if (isNaN(value)) value = null;
              }

              onChange(value, field.name, bp);
            }}
            inputProps={{ min: 0 }}
          />
        </Stack>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 1 }} />
      </React.Fragment>
    );
  },
  compareProps
);

export default XGUITextField;
